import { render, staticRenderFns } from "./AdminSection.vue?vue&type=template&id=6f596eee&scoped=true"
import script from "./AdminSection.vue?vue&type=script&lang=js"
export * from "./AdminSection.vue?vue&type=script&lang=js"
import style0 from "./AdminSection.vue?vue&type=style&index=0&id=6f596eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f596eee",
  null
  
)

export default component.exports